module.exports = __webpack_public_path__ + "static/header-donate-3b608cb4e66459df9ca5a5448b518bce.jpg";